import AVdxbTextField from './index.vue';

AVdxbTextField.install = app => {
  app.component(AVdxbTextField.name, AVdxbTextField);
};

export default AVdxbTextField;
